<div class="container-fluid">
  <div class="form-horizontal">
    <h3>
      {{ 'events.settings.promo-codes.title' | translate | titlecase }}
      <span>
        <a href="https://support.weblinkinternational.com/hc/en-us/articles/235639008-Event-Settings-Promo-Codes" target="_blank">
          <img
            src="/assets/img/help.png"
            title="{{ 'events.settings.promo-codes.promo-codes-title-help' | translate }}"
            class="wc-help-icon"
          />
        </a>
      </span>
    </h3>

    <p>
      <button app-add-button
        class="atlas-btn atlas-btn-secondary mr-10"
        [disabled]="userAccessLevel < 2"
        [label]="'events.settings.promo-codes.add-button-label' | translate | uppercase"
        (onClick)="newEventPromoCodes()"
      >
      </button>

      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary pull-right"
        (click)="exportAllPromoCodes()"
        icon="pi pi-download"
        [label]="'events.settings.promo-codes.export-usage-button-label' | translate | uppercase"
      ></button>
    </p>

    <p [hidden]="!loadingPromoCodes">
      <wl-busy [show]="loadingPromoCodes"></wl-busy>
    </p>

    <div [hidden]="!loadPromoCodesError" class="text-danger">
      <h4>{{ 'common.error' | translate | titlecase }}</h4>
      {{ loadPromoCodesError }}
    </div>

    <p-table [showGridlines]="true" #promoCodesDataGrid [rows]="100" [value]="eventPromoCodes" [hidden]="loadingPromoCodes">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'events.settings.promo-codes.promo-name-column-header' | translate | titlecase }}</th>
          <th>{{ 'events.settings.promo-codes.code-column-header' | translate | titlecase }}</th>
          <th class="text-right">{{ 'events.settings.promo-codes.discount-column-header' | translate | titlecase }}</th>
          <th>{{ 'events.settings.promo-codes.used-column-header' | translate | titlecase }}</th>
          <th>{{ 'events.settings.promo-codes.max-uses-column-header' | translate | titlecase }}</th>
          <th class="text-right">{{ 'events.settings.promo-codes.total-discounts-column-header' | translate | titlecase }}</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dataItem>
        <tr>
          <td>{{ dataItem.Name }}</td>
          <td>{{ dataItem.Code }}</td>
          <td class="text-right">
            <div>
              <span *ngIf="dataItem.DiscountType == 0">{{ dataItem.Discount | currency }}</span>
              <span *ngIf="dataItem.DiscountType == 1">{{ dataItem.Discount }}%</span>
            </div>
          </td>
          <td>{{ dataItem.Used }}</td>
          <td>
            {{
              dataItem.MaxUses && dataItem.MaxUses > 0
                ? dataItem.MaxUses
                : ('events.settings.promo-codes.no-max-uses' | translate | ucfirst)
            }}
          </td>
          <td class="text-right">{{ -dataItem.TotalDiscounts | currency }}</td>
          <td>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-secondary"
              (click)="editPromoCode(dataItem.PromoCodeId)"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-pencil"
              [label]="'common.edit' | translate | uppercase"
            ></button>

            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-danger"
              (click)="confirmDeletePromoCode(dataItem.PromoCodeId)"
              [disabled]="Used > 0 || userAccessLevel < 2"
              icon="pi pi-trash"
              [label]="'common.delete' | translate | uppercase"
            ></button>

            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-secondary"
              (click)="exportPromoCode(dataItem.PromoCodeId)"
              icon="pi pi-download"
              [label]="'common.export' | translate | uppercase"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #eventPromoCodeModal
  modal="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.settings.promo-codes.title' | translate | titlecase }}</h4>
  </ng-template>
  <div class="container-fluid">
    <div class="form-horizontal">
      <p [hidden]="!loadPromoCodeState.busy">
        <wl-busy [show]="loadPromoCodeState.busy"></wl-busy>
      </p>

      <div class="alert alert-danger" *ngIf="loadPromoCodeState.message && !loadPromoCodeState.success">
        {{ loadPromoCodeState.message }}
      </div>

      <form #promoCodeForm="ngForm" [hidden]="loadPromoCodeState.busy || !loadPromoCodeState.success">
        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.name-label' | translate | titlecase }}
          </label>

          <div class="col-sm-9 col-md-10">
            <input class="form-control" type="text" name="promoCodeName" [(ngModel)]="selectedEventPromoCode.Name" required />
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.code-label' | translate | titlecase }}
          </div>

          <div class="col-sm-9 col-md-10">
            <input class="form-control" type="text" name="promoCodeCode" [(ngModel)]="selectedEventPromoCode.Code" required />
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-md-offset-2 col-sm-6">
            {{ 'events.settings.promo-codes.code-warning-label' | translate | titlecase }}
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.adjustment-type-label' | translate | titlecase }}
          </label>

          <div class="col-sm-9 col-md-10">
            <wl-adjustment-type-selector
              [includeNoneValue]="false"
              name="promoCodeAdjustmentType"
              [(ngModel)]="selectedEventPromoCode.AdjustmentTypeId"
            ></wl-adjustment-type-selector>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.discount-type-label' | translate | titlecase }}
          </label>

          <div class="col-sm-9 col-md-10">
            <div class="form-control-static">
              <label class="mr-5">
                <input type="radio" name="discoutType" [value]="0" [(ngModel)]="selectedEventPromoCode.DiscountType" />
                {{ 'events.settings.promo-codes.dollar-option' | translate | titlecase }}
              </label>
              <label>
                <input type="radio" name="discoutType" [value]="1" [(ngModel)]="selectedEventPromoCode.DiscountType" />
                {{ 'events.settings.promo-codes.percent-option' | translate | titlecase }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.discount-amount-label' | translate | titlecase }}
          </label>

          <div class="col-sm-9 col-md-10">
            <div class="input-group">
              <span class="input-group-addon" [hidden]="selectedEventPromoCode.DiscountType != 0">$</span>
              <input class="form-control" type="number" name="promoCodeDiscountAmount" [(ngModel)]="selectedEventPromoCode.Discount" />
              <span class="input-group-addon" [hidden]="selectedEventPromoCode.DiscountType != 1">%</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-md-offset-2 col-sm-9 col-md-10">
            <label>
              <input type="checkbox" name="applyOncePerReg" [(ngModel)]="selectedEventPromoCode.ApplyOncePerReg" />
              {{ 'events.settings.promo-codes.apply-once-per-registration-label' | translate | titlecase }}
            </label>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.applies-to-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9 col-md-10">
            <div>
              <wl-busy [show]="loadingEventItems" [isLarge]="true"></wl-busy>
            </div>
            <div *ngFor="let eventItem of eventItems; let promoCodeNdx = index">
              <label>
                <input
                  type="checkbox"
                  class="text-center"
                  [name]="'promoCodeEventItemApply' + promoCodeNdx"
                  [(ngModel)]="eventItem.apply"
                />
                {{ eventItem.eventItemName }}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.usage-limit-label' | translate | titlecase }}
          </label>

          <div class="col-sm-9 col-md-10">
            <input class="form-control" type="number" name="promoCodeMaxUses" [(ngModel)]="selectedEventPromoCode.MaxUses" />
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.start-date-label' | translate | titlecase }}
          </label>
          <div class="col-sm-4">
            <wl-date-selector name="promoCodeStartDate" [(ngModel)]="selectedEventPromoCode.StartDate"></wl-date-selector>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-2 control-label">
            {{ 'events.settings.promo-codes.end-date-label' | translate | titlecase }}
          </label>

          <div class="col-sm-4">
            <wl-date-selector name="promoCodeEndDate" [(ngModel)]="selectedEventPromoCode.EndDate"></wl-date-selector>
          </div>
        </div>
      </form>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!saveError">
      {{ saveError }}
    </div>
    <wl-busy [show]="saving"></wl-busy>
    <wl-save-cancel-actions
      [isSaving]="saving"
      [isSaveDisabled]="!promoCodeForm.valid"
      (onSave)="savePromoCode()"
      (onCancel)="this.showEditModal = false"
    >
    </wl-save-cancel-actions>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeletePromoCodeModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  {{ 'events.settings.promo-codes.delete-confirm' | translate }}
  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!deleteError">
      {{ deleteError }}
    </div>
    <wl-busy [show]="deleting"></wl-busy>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="deletePromoCode()" [disabled]="deleting" icon="pi pi-trash">
      <span [hidden]="deleting">{{ 'common.delete' | translate | uppercase }}</span>
      <span [hidden]="!deleting">{{ 'common.deleting' | translate | uppercase }}</span>
    </button>

    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showDeleteModal = false"
      [disabled]="deleting"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | uppercase"
    ></button>
  </ng-template>
</p-dialog>
